import { WSElement, WSText } from "@wingspanhq/fe-component-library";
import { useUserId } from "../../../query/hooks/helpers";
import { useQueryPayrollSettings } from "../../../query/payments/queries";
import { LabelMethod } from "../../Settings/components/LabelMethod";
import styles from "./EmbeddedPreviewFundingMethod.module.scss";

export const EmbeddedPreviewFundingMethod = () => {
  const userId = useUserId();
  const queryPayrollSettings = useQueryPayrollSettings(userId);

  if (queryPayrollSettings.isLoading) {
    return <WSElement shimmer className={styles.shimmer} />;
  }

  const fundingSource = queryPayrollSettings.data?.fundingSource;

  if (!fundingSource) {
    return <WSText color="gray400">No funding method set</WSText>;
  }

  return (
    <LabelMethod
      type={fundingSource.fundingSourceType}
      id={fundingSource.fundingSourceId}
    />
  );
};
